// https://github.com/brohlson/gatsby-plugin-anchor-links/blob/master/src/components/AnchorLink.js
import _ from 'lodash'
import React from 'react'
import styled from 'styled-components'
import getSentimentColors from '../../utils/getSentimentColors'

const Path = styled.code`
	margin-left: 6px;
	font-family: monospace;
`

const Tag = styled.span`
	display: inline-block;
	box-shadow: none !important;
	white-space: nowrap;
	flex-grow: 0;
	flex-shrink: 0;
	padding: 0px 8px;
	font-size: 13px;
	line-height: 23px;

	border-radius: 6px;
	font-weight: 500;

	background: ${props => props.$background};
	color: white;

	${props =>
		props.onClick &&
		`
    cursor: pointer;

    &:hover {
      opacity: 0.8
    }
    `};
	&,
	& * {
		white-space: nowrap;
	}
`

const Root = styled.a`
	display: inline-flex;
	align-items: center;

	cursor: pointer;

	margin: 2px 0px;
	padding: 4px;
	padding-right: 6px;

	background: rgb(245, 245, 245);
	border-radius: 6px;
	/* border: solid 1px rgb(234, 234, 234); */

	white-space: nowrap;

	&:hover {
		text-decoration: none !important;
		opacity: 0.8;
	}
`

const methodToSentiment = {
	GET: 'important',
	POST: 'positive',
	PUT: 'positive',
}

const API_ENDPOINTS = {
	'POST /client-session': {
		url: 'https://primer.io/docs/api/api-reference/client-session-api/create-client-side-token',
	},
	'PATCH /client-session': {
		url: 'https://primer.io/docs/api/api-reference/client-session-api/update-client-side-token',
	},
	'POST /payments': {
		url: 'https://primer.io/docs/api/api-reference/payments-api/create-payment',
	},
	'POST /payments/<YOUR-PAYMENT-ID>/resume': {
		path: '/payments/{paymentId}/resume',
		url: 'https://primer.io/docs/api/api-reference/payments-api/resume-payment',
	},
	'POST /payments/<YOUR-PAYMENT-ID>/adjust-authorization': {
		path: '/payments/{paymentId}/adjust-authorization',
		url: 'https://primer.io/docs/api/api-reference/payments-api/adjust-authorization',
	},
	'POST /payments/<PAYMENT_ID>/cancel': {
		path: '/payments/{paymentId}/cancel',
		url: 'https://primer.io/docs/api/api-reference/payments-api/cancel-payment',
	},
	'POST /payments/<PAYMENT_ID>/refund': {
		path: '/payments/{paymentId}/refund',
		url: 'https://primer.io/docs/api/api-reference/payments-api/refund-payment',
	},
	'GET /payments/<PAYMENT_ID>': {
		path: '/payments/{paymentId}',
		url: 'https://primer.io/docs/api/api-reference/payments-api/get-payment-by-id',
	},
	'GET /payment-instruments': {
		url: 'https://primer.io/docs/api/api-reference/payment-methods-api/get-payment-methods-payment-methods-get',
	},
	'DELETE /payment-instruments/<PAYMENT_METHOD_TOKEN>': {
		path: '/payment-instruments/{paymentMethodToken}',
		url: 'https://primer.io/docs/api/api-reference/payment-methods-api/delete-payment-method-payment-methods-token-delete',
	},
}

export const getApiEndpointDefinition = ({ method, path }) => API_ENDPOINTS[`${method} ${path}`]

const ApiEndpoint = ({ method, path }) => {
	const sentiment = methodToSentiment[_.toUpper(method)]
	const endpointDefinition = API_ENDPOINTS[`${method} ${path}`]

	return (
		<Root href={endpointDefinition?.url} target='_blank' rel='noopener noreferer'>
			<Tag $background={getSentimentColors(sentiment).fg}>{_.toUpper(method)}</Tag>
			<Path style={{ color: getSentimentColors(sentiment).fg }}>{endpointDefinition?.path ?? path}</Path>
		</Root>
	)
}

export default ApiEndpoint
